import { HttpStatusCode } from "axios";
import { alertConstants } from "../../helper/sweet-alert";
import DepartmentService from "../../apiServices/masters/departmentService";
import {
  setDepartment,
  setDepartments,
} from "../../store/slices/master/departmentSlice";
import { setHelpMail } from "../../store/slices/common/commonSlice";

export function getDepartment(id?: number) {
  return async function (dispatch: any, getState: any) {
    let response = await DepartmentService.getDepartment(id);
    if (response?.success === true) {
      dispatch(setDepartment(response.data));
    } else {
      console.log("error");
    }
  };
}

export function getAllDepartments() {
  return async function (dispatch: any, getState: any) {
    let response = await DepartmentService.getDepartments();
    if (response?.success === true) {
      dispatch(setDepartments(response.data));
    } else {
      console.log("error");
    }
  };
}

export function createDepartment(data: any, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await DepartmentService.createDepartment(data);
    const name = data.get("name")
    if (response?.success === true) {
      callback(alertConstants.success);
    } else {
      if (response.status === HttpStatusCode.Conflict) {
        callback(alertConstants.conflict, name);
      } else {
        callback(alertConstants.error);
      }
    }
  };
}

export function updateDepartment(data: any, id: number, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await DepartmentService.updateDepartment(data, id);
    if (response?.success === true) {
      callback(alertConstants.success);
    } else {
      if (response.status === HttpStatusCode.Conflict) {
        callback(alertConstants.conflict);
      } else {
        callback(alertConstants.error);
      }
    }
  };
}

export function deleteDepartment(id: number, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await DepartmentService.deleteDepartment(id);
    if (response === true) {
      callback(alertConstants.inactiveSuccess);
    } else {
      callback(alertConstants.inactiveFailure);
    }
  };
}

export function getEmailIdByDepartment() {
  return async function (dispatch: any, getState: any) {
    let response = await DepartmentService.getEmailIdByDepartment();
    if (response?.success === true) {
      dispatch(setHelpMail(response.data));
    } else {
      console.log("error");
    }
  };
}